var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 3.39C5.52488 3.39 3.98293 3.39 2.69032 3.62101C2.07073 3.73175 1.58263 4.2049 1.4496 4.82009C1.23999 5.78945 1.23999 6.69366 1.23999 8.07C1.23999 9.44634 1.23999 10.3505 1.4496 11.3199C1.58263 11.9351 2.07073 12.4083 2.69032 12.519C3.98293 12.75 5.52488 12.75 6.99999 12.75C8.4751 12.75 10.0171 12.75 11.3097 12.519C11.9293 12.4083 12.4174 11.9351 12.5504 11.3199C12.76 10.3505 12.76 9.44634 12.76 8.07C12.76 6.69366 12.76 5.78945 12.5504 4.82009C12.4174 4.2049 11.9293 3.73175 11.3097 3.62101C10.0171 3.39 8.4751 3.39 6.99999 3.39Z",
    fill: "#DBEAFE",
    stroke: "#1D4ED8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59998 3.15V2.75C4.59998 1.64543 5.49541 0.75 6.59998 0.75H7.39998C8.50455 0.75 9.39998 1.64543 9.39998 2.75V3.15",
    stroke: "#1D4ED8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31282 6.63864C8.31282 6.63864 7.81927 6.08847 7.01877 6.15722C6.21827 6.22598 5.8324 6.71778 5.8324 7.21094C5.8324 8.64928 8.31282 7.65249 8.31282 9.12747C8.31282 9.88788 6.66746 10.4246 5.68716 9.53004",
    stroke: "#4147D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11688 5.19L7.11688 6.15127",
    stroke: "#4147D5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11688 9.98874L7.11688 10.95",
    stroke: "#4147D5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/MoneyBag.0bc5cdb386c7e0bd4d1c84e0f81dc007.svg";
export { ForwardRef as ReactComponent };